<div class="member-search-component" #controlRoot  [ngClass]="{ 'bcu-invalid': !isValid }">
    <form [formGroup]="memberForm">
        <div class="form-group form-horizontal input-with-clear align-self-center" *ngIf="!searchVisible">
            <span class="ic_avatar member-avatar" ></span>
            <input class="form-control search-control" type="text" [disabled]="disabled"
                placeholder="{{'MemberSearch.MemberSearchPhrasePlaceholder' | translate}}"
                [value]="selectedMemberName" (focus)="onFocus()">
            <span class="arrow-down"></span>
        </div>
        <div class="form-group form-horizontal align-self-center" *ngIf="searchVisible">
            <!-- <span class="ic_avatar member-avatar"></span> -->
            <input bcInputAutoFocus maxlength="100" class="form-control search-control" type="text" formControlName="member"
                (keyup.enter)="onSearch()" placeholder="{{'MemberSearch.MemberSearchPhrasePlaceholder' | translate}}">
            <bcu-local-spinner [size]="25" [visible]="isBusy" *ngIf="isBusy"></bcu-local-spinner>
        </div>
    </form>

    <div>
        <div class="results ml-0 mt-0 bg-white" *ngIf="searchVisible" [ngClass]="{'w-100': !isDropDownWidthProvided }"
            [style.width.px]="dropDownWidth">
            <div *ngFor="let item of members" class="result-item px-3" (click)=onItemClick(item)>
                <div class="row no-gutters justify-content-start align-items-center py-2">
                    <div class="col-1">
                        <div
                            class="circle-initials rounded-circle d-flex justify-content-center align-items-center align-self-center text-uppercase bay-club-blue-bg white">
                            {{item.firstName | initials}} {{item.lastName | initials}}
                        </div>
                    </div>
                    <div class="col-6 result-title font-weight-bold pl-2">
                        {{item.firstName}} {{item.lastName }}
                    </div>
                    <div class="col-5 text-right text-dimmed">
                        {{'MemberSearch.MemberIdLabel' | translate}} {{item.id }}
                    </div>
                    <!-- <div class="col result-title font-weight-bold">{{item.firstName}} {{ item.lastName}}</div> -->
                </div>
            </div>

            <div *ngIf="!hasItems">
                <div class="row no-result-row pl-4">
                    <div class="cold-md-12">{{'MemberSearch.NoResults' | translate}}</div>
                </div>
            </div>
        </div>
    </div>

</div>
